import React from "react";
import WireframingContent from "./wireframingContent";
import WireframingSketch from "./img/wireframe-sketch.png";
import WireframingLores from "./img/wireframe-lores.png";

function WireframingSection() {
	return (
		<section className="content-block" id={WireframingContent.meta}>
			<h4 className="section-title-meta"> {WireframingContent.meta} </h4>
			<h3 className="section-title"> {WireframingContent.title} </h3>
			{WireframingContent.paras.map((p) => {
				return <p>{p}</p>;
			})}
			<figure className="image">
				<img src={WireframingSketch} alt={WireframingContent.img01alt} />
				<figcaption>{WireframingContent.img01caption}</figcaption>
			</figure>
			<figure className="image">
				<img src={WireframingLores} alt={WireframingContent.img02alt} />
				<figcaption>{WireframingContent.img02caption}</figcaption>
			</figure>
			<span className="table-border">
				<table className="table">
					<thead>
						<tr>
							<th>{WireframingContent.table.th01}</th>
							<th>{WireframingContent.table.th02}</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<ul className="questions-list">
									{WireframingContent.table.list01.map((li) => {
										return <li>{li}</li>;
									})}
								</ul>
							</td>
							<td>
								<ul className="questions-list">
									{WireframingContent.table.list02.map((li) => {
										return <li>{li}</li>;
									})}
								</ul>
							</td>
						</tr>
					</tbody>
				</table>
			</span>
			<figcaption>{WireframingContent.table.caption}</figcaption>
		</section>
	);
}

export default WireframingSection;
